import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import SpacedItems from 'shared/components/ui/SpacedItems'
import { Icon } from 'util/ui'
import { SearchBox, Button } from 'shared/ui'
import { debounce } from 'util/functions'
import { doFetchCannedReplyCategoriesAndTemplatesBySearch } from 'ducks/cannedReplies/operations'
import { useDrawer } from 'ducks/drawers/hooks'
import {
  DRAWER_TYPE_CANNED_REPLIES_OVERVIEW,
  DRAWER_TYPE_CANNED_REPLIES_UPDATE,
} from 'ducks/drawers/types'
import styles from './styles.less'

export default function CannedReplyDropdownMenuHeader() {
  const dispatch = useDispatch()

  const onSearchChange = debounce(
    useCallback(
      query => {
        dispatch(doFetchCannedReplyCategoriesAndTemplatesBySearch(query))
      },
      [dispatch]
    ),
    175
  )

  const { openDrawer: openOverviewDrawer } = useDrawer({
    type: DRAWER_TYPE_CANNED_REPLIES_OVERVIEW,
  })

  const handleOpenDrawer = useCallback(
    () => {
      openOverviewDrawer()
    },
    [openOverviewDrawer]
  )

  const { openDrawer: openCreateDrawer } = useDrawer({
    type: DRAWER_TYPE_CANNED_REPLIES_UPDATE,
  })

  const handleOpenCreateDrawer = useCallback(
    () => {
      openCreateDrawer('new')
    },
    [openCreateDrawer]
  )

  return (
    <SpacedItems.Container
      className={styles.header}
      direction="horizontal"
      gap="mini"
    >
      <SpacedItems.Item grow={1}>
        <SearchBox
          onSearchChange={onSearchChange}
          placeholder="Search..."
          styleVersion="v2"
        />
      </SpacedItems.Item>
      <SpacedItems.Item>
        <Button
          basic
          icon
          onClick={handleOpenCreateDrawer}
          className={styles.button}
        >
          <Icon name="pencil" />
        </Button>
      </SpacedItems.Item>
      <SpacedItems.Item>
        <Button basic icon onClick={handleOpenDrawer} className={styles.button}>
          <Icon name="cog" />
        </Button>
      </SpacedItems.Item>
    </SpacedItems.Container>
  )
}
